import { replaceSpecialCharacter } from "../Layout/Common/common";
import { toRelativeUrl } from "./urlHelpers";

export function handleStockStatus(prod) {
  try {
    const result = {
      isDiscontinued: false,
      isShowPrice: true,
      container: "",
      replaceUrl: "",
      substituteCode: "",
      isUnavailable: false,
      isShowBuy: true,
      stockStatusRaw: "",
      eta: "",
      stockStatus: "true",
    };
    const { stockStatus, stockStatusRaw, wesSubstituteUrl, productSubstitute, ETA } = prod || {};

    if (!stockStatus) return null;
    result.stockStatusRaw = stockStatusRaw ?? "";
    result.stockStatus = stockStatusRaw;

    const relativeUrl = toRelativeUrl(wesSubstituteUrl);

    const substituteCode = productSubstitute ?? prod.substituteCode ?? null;

    const validStatuses = [
      "OUT_OF_STOCK ITEM WILL BE SUBSTITUTED",
      "OUT OF STOCK ITEM WILL BE SUBSTITUTED",
      "DISCONTINUED NO LONGER AVAILABLE",
      "TEMPORARY_UNAVAILABLE NO ETA",
    ];

    if (stockStatus == "OUT_OF_STOCK ITEM WILL BE BACK ORDERED") {
      result.stockStatus = "OUT OF STOCK ITEM WILL BE BACK ORDERED";
    }
    if (ETA) result.eta = ETA;
    if (validStatuses.includes(stockStatus)) {
      if (stockStatus.includes("TEMPORARY_UNAVAILABLE NO ETA")) {
        if (substituteCode && substituteCode != "") {
          result.isShowPrice = false;
          result.isShowBuy = false;
          result.isSubstitute = true;
          result.substituteCode = substituteCode;
          result.replaceUrl = relativeUrl;
        } else {
          result.isDiscontinued = false;
          result.isShowPrice = true;
          result.isUnavailable = true;
          result.isShowBuy = false;
        }
      } else {
        if (relativeUrl && relativeUrl != "" && substituteCode) {
          result.isShowPrice = false;
          result.isSubstitute = true;
          result.replaceUrl = relativeUrl;
          result.substituteCode = substituteCode;
          result.isShowBuy = false;
        } else {
          result.isDiscontinued = true;
          result.isShowPrice = false;
          result.isShowBuy = false;
        }
      }
      return result;
    } else {
      return result;
    }
  } catch (err) {
    console.error("Error in handleStockStatus:", err);
  }
  return null;
}
